import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';

import { uploadCategories, getCsvCategoriesModel } from '../app/store/actions/categories';
import UploadFilesComponent from '../components/upload';
import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';

class UploadCategoriesPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  sendFile = async (file) => {
    await this.props.uploadCategories(file);
  }

  modelDownload = async () => {
    await this.props.getCsvCategoriesModel();
  }

  goBack = () => {
    history.push(ROUTES.CATEGORY);
  }

  render() {
    return (
      <div className="main-div-tables">
        <div className="main-table">
          <h2><Translate value="importCategories" /></h2>

          <div className="upload-text">
            <p><strong><Translate value="uploadUserText1" /></strong></p>
            <p><Translate value="uploadUserText2" /></p>
            <p><Translate value="uploadUserText3" /></p>
            <p><Translate value="uploadUserText9" /></p>
            <ul>
              <li>
                <strong>name: </strong>
                (
                <Translate value="categoryName2" />
                )
              </li>
              <li>
                <strong>parentId: </strong>
                (
                <Translate value="categoryFatherExplanation" />
                )
              </li>
              <li>
                <strong>isSustainable: </strong>
                <Translate value="categoryImportText1" />
              </li>
            </ul>
          </div>

          <UploadFilesComponent
            sendFile={this.sendFile}
            goBack={this.goBack}
            modelDownload={this.modelDownload}
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  uploadCategories: file => dispatch(uploadCategories(file)),
  getCsvCategoriesModel: () => dispatch(getCsvCategoriesModel()),
});

export default connect(null, mapDispatchToProps)(UploadCategoriesPage);
